<div class="icon-input-container" (click)="onShowPanel($event)">
  <input class="form-control"
         #inputRef
         [value]="selectedText"
         [required]="isRequired"
         [placeholder]="ngPlaceholder || ('Agents' | translate)"
         [ngClass]="isDisabled ? 'disabled': 'enabled'"
         readonly>
  <bringoz-icon iconName="chevron-down" class="input-icon right pointer gray-102"></bringoz-icon>
</div>
